module.exports = __webpack_public_path__ + "img/home1.b9da30c0.jpg";